<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <path
                    id="Path_243"
                    data-name="Path 243"
                    d="M12,0H36A12.035,12.035,0,0,1,48,12V36A12.035,12.035,0,0,1,36,48H12A12.035,12.035,0,0,1,0,36V12A12.035,12.035,0,0,1,12,0Z" />
            </clipPath>
            <linearGradient
                :id="`linear-gradient-${uniqueId}`"
                x1="0.21"
                y1="-0.009"
                x2="0.942"
                y2="0.635"
                gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#005ab9" />
                <stop offset="1" stop-color="#1e3764" />
            </linearGradient>
            <linearGradient
                :id="`linear-gradient-2-${uniqueId}`"
                x1="0.062"
                y1="1.467"
                x2="0.839"
                y2="2.095"
                gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#fba900" />
                <stop offset="1" stop-color="#ffd800" />
            </linearGradient>
        </defs>
        <g id="Group_1032" data-name="Group 1032" :clip-path="`url(#clip-path-${uniqueId})`">
            <path
                id="Path_240"
                data-name="Path 240"
                d="M11.5.5h24a11.1,11.1,0,0,1,11,11v24a11.1,11.1,0,0,1-11,11h-24a11.1,11.1,0,0,1-11-11v-24A11.1,11.1,0,0,1,11.5.5Z"
                transform="translate(0.5 0.5)"
                fill="rgba(255,255,255,0)"
                stroke="rgba(238,238,238,0)"
                stroke-width="1" />
            <g id="Group_1440" data-name="Group 1440" transform="translate(6 16.4)">
                <path
                    id="Path_241"
                    data-name="Path 241"
                    d="M10.6,19.6c5.4,0,7.8-3.8,10.4-7.6H3v7.6Z"
                    transform="translate(-3 -4.4)"
                    :fill="`url(#linear-gradient-${uniqueId})`" />
                <path
                    id="Path_242"
                    data-name="Path 242"
                    d="M22.4,8.2C17,8.2,14.6,12,12,15.8H30V8.2Z"
                    transform="translate(6 -8.2)"
                    :fill="`url(#linear-gradient-2-${uniqueId})`" />
            </g>
            <g
                id="Group_1441"
                data-name="Group 1441"
                transform="translate(6 16.4)"
                style="mix-blend-mode: color; isolation: isolate">
                <path
                    id="Path_241-2"
                    data-name="Path 241"
                    d="M10.6,19.6c5.4,0,7.8-3.8,10.4-7.6H3v7.6Z"
                    transform="translate(-3 -4.4)"
                    fill="#bfbca5" />
                <path
                    id="Path_242-2"
                    data-name="Path 242"
                    d="M22.4,8.2C17,8.2,14.6,12,12,15.8H30V8.2Z"
                    transform="translate(6 -8.2)"
                    fill="#bfbca5" />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
